module.exports = __webpack_public_path__ + "static/media/makersplacev3.caf97834.svg";